var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-full" },
    [
      _vm.loading && _vm.buttons
        ? _c("v-skeleton-loader", {
            staticClass: "mx-auto",
            attrs: {
              "max-width": "300",
              type: "list-item, list-item, list-item",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.autocomplete && !_vm.buttons && !_vm.iterator
        ? _c("v-select", {
            attrs: {
              multiple: _vm.multiple,
              items: _vm.locations,
              value: _vm.value,
              "item-text": "name",
              "item-value": "id",
              label: _vm.label,
              "prepend-inner-icon": "storefront",
              outlined: "",
              rules: _vm.rules,
              loading: _vm.loading,
              "hide-details": _vm.hideDetails,
              readonly: _vm.readonly,
              dense: "",
            },
            on: {
              input: function ($event) {
                return _vm.$emit("input", $event)
              },
              focus: function ($event) {
                return _vm.$emit("focus")
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.buttons && !_vm.loading
        ? _c(
            "v-list",
            _vm._l(_vm.locations, function (location) {
              return _c(
                "v-list-item",
                { key: location.id },
                [
                  _c("SoliAvatarBtn", {
                    attrs: {
                      avatar: location.alt_image
                        ? `${location.alt_image}/m/80x80`
                        : "/musicologie-m-white.png",
                      subtitleBottom: _vm.showAddress ? location.address : null,
                      title: location.name,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("input", location)
                      },
                    },
                  }),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.autocomplete && !_vm.buttons && !_vm.iterator
        ? _c("v-autocomplete", {
            staticClass: "soli-blue-text",
            attrs: {
              value: _vm.value,
              items: _vm.locations,
              rules: _vm.rules,
              "item-text": "name",
              "item-value": "id",
              label: _vm.label,
              loading: _vm.loading,
              appendIcon: "my_location",
              outlined: "",
              "prepend-inner-icon": "storefront",
              dense: "",
              "error-messages": _vm.error,
              "hide-details": _vm.hideDetails,
            },
            on: {
              input: function ($event) {
                return _vm.$emit("input", $event)
              },
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                $event.preventDefault()
              },
              "click:append": function ($event) {
                return _vm.askForLocation()
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "item",
                  fn: function (data) {
                    return [
                      _c(
                        "v-list-item-avatar",
                        { staticClass: "shadow-blue", attrs: { size: "56" } },
                        [
                          _c("img", {
                            attrs: {
                              src: data.item.alt_image
                                ? `${data.item.alt_image}/m/80x80`
                                : "/musicologie-m-white.png",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", {
                            staticClass: "font-weight-bold body-2",
                            domProps: { innerHTML: _vm._s(data.item.name) },
                          }),
                          _vm._v(" "),
                          _c("v-list-item-subtitle", {
                            domProps: { innerHTML: _vm._s(data.item.address) },
                          }),
                          _vm._v(" "),
                          _vm.getDistance
                            ? _c(
                                "v-list-item-subtitle",
                                {
                                  staticClass: "accent--text font-weight-bold",
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        `${data.item.distance} | ${data.item.duration}`
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              781115702
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.iterator && _vm.loading
        ? _c("v-skeleton-loader", {
            staticClass: "mx-auto my-3",
            attrs: {
              type: "list-item-avatar, list-item-avatar, list-item-avatar",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.iterator && !_vm.loading
        ? _c("v-data-iterator", {
            attrs: {
              items: _vm.locations,
              "disable-pagination": "",
              search: _vm.search,
              "hide-default-footer": "",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function () {
                    return [
                      _vm.locations.length > 1 && !_vm.hideSearch
                        ? _c(
                            "v-sheet",
                            {
                              staticStyle: {
                                position: "sticky",
                                top: "0px",
                                "z-index": "10",
                              },
                              attrs: { light: "" },
                            },
                            [
                              _c("SoliText", {
                                staticClass: "pa-3",
                                attrs: {
                                  icon: "storefront",
                                  autofocus: _vm.autofocus,
                                  label: "Search Locations",
                                  hideDetails: "",
                                  fullRound: "",
                                  appendIcon: "my_location",
                                  loading: _vm.loading,
                                },
                                on: {
                                  append: function ($event) {
                                    return _vm.askForLocation()
                                  },
                                },
                                model: {
                                  value: _vm.search,
                                  callback: function ($$v) {
                                    _vm.search = $$v
                                  },
                                  expression: "search",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "item",
                  fn: function (data) {
                    return [
                      _c(
                        "v-list",
                        {
                          staticClass: "py-0 px-3 soli-round",
                          class: {
                            expanded:
                              _vm.expandable &&
                              data.item.id == _vm.selectedLocation?.id,
                          },
                        },
                        [
                          !_vm.expandable ||
                          data.item.id !== _vm.selectedLocation?.id
                            ? _c(
                                "SoliAvatarBtn",
                                {
                                  staticClass: "w-full",
                                  attrs: {
                                    value:
                                      data.item.id == _vm.selectedLocation?.id,
                                    avatar: data.item.alt_image
                                      ? `${data.item.alt_image}/m/80x80`
                                      : "/musicologie-m-white.png",
                                    subtitleBottom: _vm.showAddress
                                      ? data.item.market?.name
                                      : null,
                                    blueShadow: "",
                                    outlined: false,
                                    title: data.item.name,
                                    icon: data.item.icon ?? null,
                                    append:
                                      _vm.expandable && !_vm.getDistance
                                        ? "expand_more"
                                        : null,
                                    ripple: !_vm.expandable,
                                    id: data.item.id,
                                  },
                                  on: {
                                    click: function ($event) {
                                      ;[
                                        _vm.$emit(
                                          "input",
                                          _vm.returnObject
                                            ? data.item
                                            : data.item.id
                                        ),
                                        (_vm.selectedLocation =
                                          data.item.id ==
                                          _vm.selectedLocation?.id
                                            ? null
                                            : data.item),
                                      ]
                                    },
                                  },
                                },
                                [
                                  [
                                    _vm.getDistance
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "accent--text font-weight-bold w-full h-full top-0 left-0 flex justify-end align-center pa-3",
                                            staticStyle: {
                                              "text-transform": "none",
                                              position: "absolute",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  `${data.item.distance} | ${data.item.duration}`
                                                ) +
                                                "\n                        "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.expandable
                            ? _c("SoliLocationExpandedContent", {
                                staticClass: "mt-3",
                                attrs: {
                                  location: data.item,
                                  value: _vm.selectedLocation,
                                },
                                on: {
                                  input: function ($event) {
                                    ;[(_vm.selectedLocation = data.item)]
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              4261249069
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showLocationError
        ? _c("SoliChoice", {
            attrs: {
              title: "Location Lookup Failed",
              subtitle:
                "Location Services is currently disabled. Please enable it to use your current location.",
              button1: "Okay",
            },
            on: {
              option1: function ($event) {
                _vm.closeModal(() => (_vm.showLocationError = false))
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }